import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { ListChecks, X } from 'lucide-react';

import EventTaskLinksPanel from './EventTaskLinksPanel';

export default function EventTaskLinksDialog({
  event,
  open,
  onClose,
  onLinksChange,
  initialTravelOpen = false,
}) {
  if (!event) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: (theme) => ({
          bgcolor: theme.palette.background.default,
          border: `3px solid ${theme.palette.orange.main}`,
          borderRadius: 5,
          boxShadow: `0 0 28px ${theme.palette.orange.main}44`,
        }),
      }}
    >
      <DialogTitle sx={{ p: 2, pb: 1 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" spacing={1} alignItems="center" sx={{ color: 'primary.main' }}>
            <ListChecks size={22} />
            <Typography variant="h6" sx={{ color: 'primary.main' }}>
              Tasks for {event.title}
            </Typography>
          </Stack>
          <IconButton aria-label="Close tasks" onClick={onClose} sx={{ color: 'secondary.main' }}>
            <X />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 1.5, sm: 2.5 }, pb: 3 }}>
        <EventTaskLinksPanel
          event={event}
          onLinksChange={onLinksChange}
          initialTravelOpen={initialTravelOpen}
        />
      </DialogContent>
    </Dialog>
  );
}
